import { mapState, mapMutations, mapActions } from "vuex"

export default {
  computed: {
    ...mapState({
      USER: (state) => state.user,
      LANG: (state) => state.locale,
    }),
  },
  methods: {
    ...mapMutations({
      SET_USER: "user/SET",
    }),
    ...mapActions({
      IMPORT_USER_TO_LOGIN: "login/IMPORT_EXISTING_USER",
    }),
    checkForAlreadyExistingUsr() {
      this.loading = true
      return new Promise((resolve, reject) => {
        this.$axios
          .$get(`/auth/user/${this.USER.email}/`)
          .then((resp) => {
            this.loading = false
            this.IMPORT_USER_TO_LOGIN(resp)
            reject(false)
          })
          .catch(() => {
            resolve(true)
          })
      })
    },
  },
}
